import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import { NOT_INSURED_ISSUER_SLUG } from "../lib/constants";
export default function shouldShowFallbackIcon(hideIssuerLogos, id) {
    return (hideIssuerLogos &&
        Boolean(id) &&
        id !== AllIssuers.OTHER &&
        id !== NOT_INSURED_ISSUER_SLUG);
}
